import { UserAddOutlined } from '@ant-design/icons';
import {
  CustomWarningsRule,
  Datatype,
  getSimpleWidgetReference,
  InputCommonTranslationSchema,
  RequiredRule,
  tran,
  WidgetCategory,
  WidgetMainType,
  WidgetType,
  type IWidgetType,
} from '@framework/engine';
import { CandidateWidgetComponent } from './CandidateWidgetComponent';
import {
  CandidateWidgetConfigComponent,
  CandidateWidgetConfigSchema,
} from './CandidateWidgetConfigComponent';
import { CandidateWidgetPreview } from './CandidateWidgetPreview';
import { createCandidateSelectFormSchema } from './createCandidateSelectFormSchema';
import { getCandidateSelectColumnsReferences } from './getCandidateSelectColumnsReferences';
import type { ICandidateWidget } from './ICandidateWidget';

/**
 * Widget di selezione candidato.
 */
export const CandidateWidgetType: IWidgetType<ICandidateWidget> = {
  type: WidgetType.Candidate,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Advanced,
  name: 'Selezione Candidato',
  icon: <UserAddOutlined />,
  hasValue: true,
  getReference: getSimpleWidgetReference(Datatype.String),
  getSiblingReferences: getCandidateSelectColumnsReferences,
  formComponent: CandidateWidgetComponent,
  createFormSchema: createCandidateSelectFormSchema,
  previewComponent: CandidateWidgetPreview,
  configValidator: CandidateWidgetConfigSchema,
  configComponent: CandidateWidgetConfigComponent,
  translationSchema: tran.widget({
    ...InputCommonTranslationSchema.objectShape,
    buttonText: tran.string(),
  }),
  configOptions: {
    removeCollapsePanel: true,
    hideDirectives: true,
  },
  rules: [RequiredRule, CustomWarningsRule],
};
